import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _NumberInput;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { omitProps } from '@instructure/ui-react-utils';
import testable from '@instructure/ui-testable';
import { FormPropTypes, NumberInput as NumberInputControlled, TextInput } from '@instructure/quiz-common';
import { Decimal, Locale } from '@instructure/quiz-i18n';
import { formatValue } from '../../util/formatValue';
import { getPrecision as _getPrecision } from '../../util/getPrecision';
import { xor } from '../../util/xor';
import { ApplyLocaleContext } from '@instructure/ui-i18n';
export var NumberInput = (_dec = testable(), _dec(_class = (_NumberInput = /*#__PURE__*/function (_Component) {
  function NumberInput() {
    var _this;
    _classCallCheck(this, NumberInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, NumberInput, [].concat(args));
    _defineProperty(_this, "_input", null);
    // Replicate the arrow behavior commonly seen in inputs of type number
    _defineProperty(_this, "applyStep", function (dir) {
      var d = _this.getDecimalValue(_this.props.value || '0');
      if (d.isNaN()) return d;
      if (!d.mod(_this.step).equals(0)) {
        // case when value is between steps, so we snap to the next step
        var steps = d.div(_this.step);
        if (dir > 0) {
          d = steps.floor().times(_this.step);
        } else {
          d = steps.ceil().times(_this.step);
        }
      }

      // then we add the step
      if (dir > 0) {
        d = d.plus(_this.step);
      } else {
        d = d.minus(_this.step);
      }

      // case when value is less than minimum
      if (d.lt(_this.min)) {
        return _this.min;
      }

      // case when value is more than maximum
      if (d.gt(_this.max)) {
        return _this.max;
      }
      return d;
    });
    _defineProperty(_this, "handleRef", function (element) {
      _this._input = element;
      _this.props.inputRef(element);
    });
    _defineProperty(_this, "handleBlur", function (event) {
      var decimalValue = _this.getDecimalValue(_this.props.value);
      var normalizedValue = _this.normalizeValue(decimalValue);
      if (normalizedValue != null) {
        var value = formatValue(new Decimal(normalizedValue), _this.precision, _this.locale);
        if (value !== "".concat(_this.props.value)) {
          _this.props.onChange(event, value, normalizedValue);
        }
      }
      _this.props.onBlur(event);
    });
    _defineProperty(_this, "handleChange", function (event, value) {
      var decimalValue = _this.getDecimalValue(_this.trimValue(value));
      var precision = _this.getPrecision(_objectSpread(_objectSpread({}, _this.props), {}, {
        value: value
      }), _this.locale);
      _this.props.onChange(event, value, _this.normalizeValue(decimalValue, precision));
    });
    _defineProperty(_this, "handleIncrement", function (event) {
      _this.handleStep(event, 1);
    });
    _defineProperty(_this, "handleDecrement", function (event) {
      _this.handleStep(event, -1);
    });
    return _this;
  }
  _inherits(NumberInput, _Component);
  return _createClass(NumberInput, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
      if (this.props.value == null) return;

      // If the locale or precision props change, update the input value accordingly
      var currentLocale = this.getLocale(this.props, this.context);
      var nextLocale = this.getLocale(nextProps, nextContext);
      var decimalPrecision = nextProps.decimalPrecision,
        significantDigits = nextProps.significantDigits;
      if (currentLocale === nextLocale && this.props.decimalPrecision === decimalPrecision && this.props.significantDigits === significantDigits) return;
      var decimalValue = this.getDecimalValue(this.props.value, currentLocale);
      if (decimalValue.isNaN()) return;
      var nextPrecision = this.getPrecision(nextProps, currentLocale);
      var formattedString = formatValue(decimalValue, nextPrecision, nextLocale);
      nextProps.onChange(null, formattedString, this.normalizeValue(decimalValue, nextPrecision));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Sending a normalized value on mount prevents valid numbers from being alerted as invald
      var value = this.props.value;
      var normalized = this.normalizeValue(this.getDecimalValue(this.trimValue(value)), this.getPrecision(_objectSpread(_objectSpread({}, this.props), {}, {
        value: value
      }), this.locale));
      this.props.onInitialNormalization(value, normalized);
    }
  }, {
    key: "focus",
    value: function focus() {
      this._input.focus();
    }
  }, {
    key: "getLocale",
    value: function getLocale(props, context) {
      return props.locale || context.locale || Locale.browserLocale();
    }
  }, {
    key: "getPrecision",
    value: function getPrecision(props, locale) {
      var _Decimal$getDelimiter = Decimal.getDelimiters(locale),
        decimal = _Decimal$getDelimiter.decimal;
      return _getPrecision(props, decimal);
    }
  }, {
    key: "getDecimalFromNormalizedString",
    value: function getDecimalFromNormalizedString(value) {
      return Decimal.parse(value, Locale.defaultLocale);
    }
  }, {
    key: "Component",
    get: function get() {
      return this.props.inputType === 'numeric' ? NumberInputControlled : TextInput;
    }
  }, {
    key: "min",
    get: function get() {
      return this.getDecimalFromNormalizedString(this.props.min);
    }
  }, {
    key: "max",
    get: function get() {
      return this.getDecimalFromNormalizedString(this.props.max);
    }
  }, {
    key: "step",
    get: function get() {
      return this.getDecimalFromNormalizedString(this.props.step);
    }
  }, {
    key: "locale",
    get: function get() {
      return this.getLocale(this.props, this.context);
    }
  }, {
    key: "precision",
    get: function get() {
      return this.getPrecision(this.props, this.locale);
    }
  }, {
    key: "getDecimalValue",
    value: function getDecimalValue(value) {
      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.locale;
      // Decimal.js supports formats we want to reject
      var formatIndicators = ['b',
      // binary
      'e',
      // exponential
      'o',
      // octal
      'x' // hex
      ];
      var unsupportedFormat = typeof value === 'string' ? formatIndicators.some(function (_char) {
        return value.includes(_char);
      }) : false;
      return Decimal.parse(unsupportedFormat ? '' : value, locale);
    }
  }, {
    key: "shouldFormatValueOnRender",
    value: function shouldFormatValueOnRender() {
      return typeof this.props.value === 'number' || this.props.value instanceof Number;
    }
  }, {
    key: "conditionalFormat",
    value: function conditionalFormat(value) {
      if (value == null || Number.isNaN(value)) return '';
      return this.shouldFormatValueOnRender() ? formatValue(this.getDecimalValue(value), this.precision, this.locale) : value;
    }
  }, {
    key: "normalizeValue",
    value: function normalizeValue(decimal) {
      var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.precision;
      if (decimal.isNaN()) return null;
      var value = decimal;
      if (value.lt(this.min)) value = this.min;
      if (value.gt(this.max)) value = this.max;
      return formatValue(value, precision);
    }
  }, {
    key: "handleStep",
    value: function handleStep(event, step) {
      if (this.props.disabled || this.props.readOnly) return;
      var decimalValue = this.applyStep(step);
      if (decimalValue.isNaN()) return;
      var formattedString = decimalValue.toLocaleString(this.locale);
      if (formattedString !== this.props.value) {
        this.props.onChange(event, formattedString, this.normalizeValue(decimalValue));
      }
    }
  }, {
    key: "trimValue",
    value: function trimValue(value) {
      return typeof value == 'string' ? value.trim() : value;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        disabled = _this$props.disabled,
        display = _this$props.display,
        id = _this$props.id,
        inputType = _this$props.inputType,
        renderLabel = _this$props.renderLabel,
        layout = _this$props.layout,
        messages = _this$props.messages,
        onFocus = _this$props.onFocus,
        onKeyDown = _this$props.onKeyDown,
        placeholder = _this$props.placeholder,
        readOnly = _this$props.readOnly,
        isRequired = _this$props.isRequired,
        showArrows = _this$props.showArrows,
        size = _this$props.size,
        value = _this$props.value,
        width = _this$props.width;
      var numberInputProps = inputType === 'numeric' ? {
        onDecrement: this.handleDecrement,
        onIncrement: this.handleIncrement,
        showArrows: showArrows,
        inputMode: 'decimal',
        allowStringValue: true
      } : null;
      var interaction = disabled ? 'disabled' : readOnly ? 'readonly' : 'enabled';
      return /*#__PURE__*/React.createElement(this.Component, Object.assign({}, omitProps(this.props, NumberInput.propTypes), numberInputProps, {
        interaction: interaction,
        id: id,
        display: display,
        inputRef: this.handleRef,
        renderLabel: renderLabel,
        layout: layout,
        messages: messages,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        placeholder: placeholder,
        isRequired: isRequired,
        size: size,
        value: this.conditionalFormat(value),
        width: width,
        role: 'spinbutton',
        "aria-valuemin": this.props.min,
        "aria-valuemax": this.props.max,
        "aria-valuenow": this.props.value
      }));
    }
  }]);
}(Component), _defineProperty(_NumberInput, "propTypes", {
  renderLabel: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  id: PropTypes.string,
  showArrows: PropTypes.bool,
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Specify the number of digits to display after the decimal separator. If
   * the input has more digits after the decimal separator, it will be
   * rounded on blur. If it has less, trailing zeros will be added on blur.
   *
   * Pass either decimalPrecision or significantDigits, not both.
   */
  decimalPrecision: xor(PropTypes.number, 'significantDigits'),
  /**
   * Specify the number of significant digits. If the input has more
   * significant digits, it will be rounded on blur. If it has less, traling
   * zeros will be added on blur.
   *
   * Pass either decimalPrecision or significantDigits, not both.
   */
  significantDigits: xor(PropTypes.number, 'decimalPrecision'),
  /**
   * object with shape: `{
   * text: PropTypes.string,
   * type: PropTypes.oneOf(['error', 'hint', 'success', 'screenreader-only'])
   *   }`
   */
  messages: PropTypes.arrayOf(FormPropTypes.message),
  /**
    A standard language id
  **/
  locale: PropTypes.string,
  size: PropTypes.oneOf(['medium', 'large']),
  layout: PropTypes.oneOf(['stacked', 'inline']),
  width: PropTypes.string,
  display: PropTypes.oneOf(['inline-block', 'block']),
  /**
   * Html placeholder text to display when the input has no value. This should be hint text, not a label
   * replacement.
   */
  placeholder: PropTypes.string,
  /**
   * Whether or not to disable the input
   */
  disabled: PropTypes.bool,
  /**
   * Works just like disabled but keeps the same styles as if it were active
   */
  readOnly: PropTypes.bool,
  isRequired: PropTypes.bool,
  /**
   * The type of input to use. Set this to `text` if you don't want to provide
   * any indication that you're expecting numeric input, but still need this
   * component's number internationalization features.
   */
  inputType: PropTypes.oneOf(['numeric', 'text']),
  /**
   * a function that provides a reference to the actual input element
   */
  inputRef: PropTypes.func,
  /**
   * The selected value (must be accompanied by an `onChange` prop). If this
   * is a number, it will be formatted according to the current locale. If a
   * string is given, it should already be in the correct format for the
   * current locale.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Called whenever the value of the input changes. The second argument is
   * the string value of the input; the third argument is a normalized string
   * value obtained by parsing the input string according to the current
   * locale, removing thousands separators, using the period `.` as decimal
   * separator, and rounding to the specified precision. This third argument
   * is `null` if the input value cannot be parsed.
   *
   * `onChange` is called on blur, as the value is formatted when the
   * component loses focus. In this case, `onChange` is always called *before*
   * `onBlur`.
   */
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onInitialNormalization: PropTypes.func
}), _defineProperty(_NumberInput, "contextType", ApplyLocaleContext), _defineProperty(_NumberInput, "defaultProps", {
  id: void 0,
  decimalPrecision: void 0,
  significantDigits: void 0,
  locale: void 0,
  width: void 0,
  placeholder: void 0,
  isRequired: false,
  showArrows: true,
  step: 1,
  min: null,
  max: null,
  display: 'block',
  inputType: 'numeric',
  size: 'medium',
  messages: [],
  disabled: false,
  readOnly: false,
  layout: 'stacked',
  inputRef: function inputRef(input) {},
  onChange: function onChange(event, value, normalizedValue) {},
  onKeyDown: function onKeyDown(event) {},
  onFocus: function onFocus(event) {},
  onBlur: function onBlur(event) {},
  onInitialNormalization: Function.prototype,
  value: void 0
}), _NumberInput)) || _class);
export default NumberInput;